import { render } from "./LogIn.vue?vue&type=template&id=55cda7fd"
import script from "./LogIn.vue?vue&type=script&lang=js"
export * from "./LogIn.vue?vue&type=script&lang=js"
script.render = render

export default script